import React from "react";
import Image from "./Image";
import Building from "./Building";
import Engineering from "./Engineering";
import Architecture from "./Architecture";
import Management from "./Management";

export default function Homepage() {
  return (
    <>
      <Image />
      <Building />
      <Engineering />
      <Architecture />
      <Management />
    </>
  );
}
